import { useEffect, useState } from 'react';

import { Tab } from '@headlessui/react';
import { tracking } from '@iwoca/frontend-tracking-library';
import { IconHouseFilled, IconSync } from '@iwoca/icons';
import { Card } from '@iwoca/orion';
import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';

import { TProductType } from '../../dashboard/Dashboard.types';
import * as selectors from '../accountsSelector';
import overdueStyles from './NewOverdueView.module.css';
import { OverdueAlert } from './OverdueAlert';
import { LoanInformationHeader } from '../dashboardComponents/LoanInformationHeader/LoanInformationHeader';
import { FAQs } from '../dashboardWidgets/FAQs/FAQs';
import { OverduePayments } from '../dashboardWidgets/overduePayments/OverduePayments';
import { TabularRepaymentsPanel } from '../dashboardWidgets/TabularRepaymentsPanel/TabularRepaymentsPanel';
import styles from '../NewOutstandingView/NewOutstandingView.module.css';
import OverviewPanel from '../NewOutstandingView/OverviewPanel/OverviewPanel';

type OwnProps = {
    productType: TProductType;
    accountId: string;
};

const mapStateToProps = (state: RootState, { productType }: OwnProps) => {
    return {
        loanDuration: selectors.getLoanDurationByMonth(state, productType),
        creditLimit: selectors.getMaxAmountCreditAvailable(state, productType),
        overduePaymentAmount: selectors.getNextRepaymentAmount(
            state,
            productType
        )
    };
};

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const NewOverdueView = ({
    productType,
    accountId,
    overduePaymentAmount
}: OwnProps & PropsFromRedux) => {
    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {
        tracking.ampli.dashboardViewed({
            account_id: accountId,
            // @ts-expect-error
            product_type: productType,
            dashboard_state: 'overdue'
        });
    }, [accountId, productType]);

    return (
        <div className="mx-auto mt-l max-w-3xl px-2xs pb-[125px] min-m:pb-xl">
            <OverdueAlert overdueAmount={overduePaymentAmount} />
            <Card className={styles.cardContainer}>
                <LoanInformationHeader accountId={accountId} />

                <Tab.Group
                    selectedIndex={selectedIndex}
                    onChange={setSelectedIndex}
                >
                    <Tab.List className={styles.tabsList}>
                        <Tab className={styles.tab}>
                            <IconHouseFilled className={styles.icon} /> Overview
                        </Tab>

                        <Tab className={styles.tab}>
                            <IconSync className={styles.icon} /> Repayments
                        </Tab>
                    </Tab.List>

                    <div className={styles.tabPanel}>
                        <Tab.Panels>
                            <Tab.Panel>
                                <OverviewPanel accountId={accountId} />

                                <div className={overdueStyles.actions}>
                                    <OverduePayments accountId={accountId} />
                                </div>
                            </Tab.Panel>

                            <Tab.Panel>
                                <TabularRepaymentsPanel accountId={accountId} />
                            </Tab.Panel>
                        </Tab.Panels>

                        <FAQs accountId={accountId} />
                    </div>
                </Tab.Group>
            </Card>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, null)(NewOverdueView);
